// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"6af0392b","549":"57a0685d","787":"cd52a978"}[chunkId] + ".chunk.js";
};